export default "__VITE_ASSET__1dUB072n__"